$(function () {
  var elem = document.getElementById('map'),
      elemLeft = $("#map").offset().left,
      elemTop = $("#map").offset().top,
      context = elem.getContext('2d'),
      cities = [];
  elem.width = $('#map').width() * 2;
  elem.height = elem.width * .5789;
  elem.style.width = $('#map').width();
  elem.style.height = $('#map').width() * .5789;
  $('#map').css('padding-bottom', 0);

  var size = elem.width / 80;

  elem.addEventListener('click', function(event) {
      var x = (event.pageX - elemLeft - document.documentElement.scrollLeft) * 2,
          y = (event.pageY - elemTop) * 2;

      cities.forEach(function(city) {
          if (y > city.top - size - 26 && y < city.top + size
              && x > city.left - size && x < city.left + size) {

            // TODO: generalize this for arbitrary number of slides per city?
            $('.cities.content_popup').find('a')[(city.id-1)*2].click();

          }
      });

  }, false);

  $("#map").mousemove(function (event) {
      var x = (event.pageX - elemLeft) * 2,
          y = (event.pageY - elemTop) * 2;

      cities.forEach(function(city) {
          if (y > city.top - size - 15 && y < city.top + size + 15
              && x > city.left - size - 15 && x < city.left + size + 15) {
              drawCity(city, 1);
          } else {
              drawCity(city, 0.65);
          }
      });

  });

  cities.push({
      top: elem.height * .435,
      left: elem.width * .134,
      name: "San Francisco",
      id: 1,
  },{
      top: elem.height * .346,
      left: elem.width * .475,
      name: "London",
      id: 6,
  },{
      top: elem.height * .36,
      left: elem.width * .51,
      name: "Berlin",
      id: 2,
  },{
      top: elem.height * .835,
      left: elem.width * .315,
      name: "Buenos Aires",
      id: 3,
  },{
      top: elem.height * .432,
      left: elem.width * .840,
      name: "Seoul",
      id: 4,
  },{
      top: elem.height * .566,
      left: elem.width * .708,
      name: "Hyderabad",
      id: 5,
  },{
      top: elem.height * .514,
      left: elem.width * .8313,
      name: "Taipei",
      id: 7,
  });

  drawCity = function(city, opacity) {
      if (city.name == "Berlin") {
        // TODO: better bounding box solution that doesn't overlap with other cities
      } else {
        // sweep bg for circle
        context.clearRect(city.left - (size+4), city.top - (size+4), 2*size + 8, 2*size + 8);
        // sweep bg for text
        context.clearRect(city.left - 120, city.top - size - 45, 250, 50);
      }
      context.globalAlpha = opacity;
      context.beginPath();
      context.arc(city.left, city.top, size - 10, 0, 2 * Math.PI, false);
      context.closePath();
      context.fillStyle = 'white';
      context.fill();
      context.beginPath();
      context.arc(city.left, city.top, size, 0, 2 * Math.PI, false);
      context.closePath();
      context.strokeStyle= 'white';
      context.lineWidth=6;
      context.stroke();
      if (elem.width > 1450){
        context.font = "30px Helvetica";
        context.textAlign = "center";
        if (city.name == "Berlin") {
          context.textAlign = "left";
        }
        context.fillText(city.name, city.left, city.top - size - 16);
      }
  };

  cities.forEach(function(city) {
      drawCity(city, 0.75);
  });
});



// WEBPACK FOOTER //
// client/cms/map/bundle.js